import { h } from '@stencil/core';
import { SVGOpts } from '../../../common/images/icons-opts';

export const IconPreOrder = (opts?: SVGOpts) => (
  <svg
    class={opts?.class}
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.707 1.04297L12.2852 2.46484C11.0547 1.23438 9.35938 0.46875 7.5 0.46875C3.75391 0.46875 0.691406 3.53125 0.71875 7.27734C0.71875 11.0234 3.75391 14.0312 7.5 14.0312C9.22266 14.0312 10.8359 13.375 12.0391 12.3086C12.1758 12.1719 12.1758 11.9531 12.0391 11.8164L11.4922 11.2695C11.3828 11.1602 11.1914 11.1602 11.0547 11.2695C10.0977 12.1172 8.86719 12.6094 7.5 12.6094C4.51953 12.6094 2.14062 10.2305 2.14062 7.25C2.14062 4.29688 4.51953 1.89062 7.5 1.89062C8.97656 1.89062 10.3164 2.49219 11.2734 3.47656L9.79688 4.95312C9.57812 5.17188 9.74219 5.5 10.0156 5.5H13.9531C14.1172 5.5 14.2812 5.36328 14.2812 5.17188V1.26172C14.2812 0.988281 13.9258 0.824219 13.707 1.04297Z"
      fill="#0047BA"
    />
  </svg>
);
